import React from "react"
import { QUEUES } from "./plannerItems"

// The queues of the view (ticket 15 Q6): each counts what it holds and, chosen, lists only that until it is chosen again.
// "Confirmed, incomplete" and "Ready to publish" (Phase E2p) show once Ready to publish is read (`publishing`): its rule decides them.
export default function PlannerQueues({ items, queue, now, publishing, onChange }) {
  return <div role="group" aria-label="Queues" className="ep-queues">
    {QUEUES.filter(entry => publishing || !entry.publishing).map(({ key, label, holds }) => <button type="button" key={key} aria-pressed={queue === key}
      className={"ep-queue" + (queue === key ? " is-on" : "") + (key === "waitingLong" ? " ep-queue-late" : "")}
      onClick={() => onChange(queue === key ? null : key)}>
      <b>{items.filter(item => holds(item, now)).length}</b> {label}
    </button>)}
  </div>
}
